// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import * as Sentry from "@sentry/react";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { mdiPlaylistCheck } from "@mdi/js";
import { Button, Tooltip } from "antd";
import {
  filterWellsFromList,
  setFilterToSystemDefault
} from "store/features/filter/filterSlice";
import styled from "styled-components";

import { WellListRecord } from "models/UserArpsModel";

interface IApplyWellListButton {
  wellListRecord: WellListRecord;
  setErrorMessage: React.Dispatch<React.SetStateAction<string | undefined>>;
  isActive: boolean;
  onToggleActive: (changeId: string | null) => void;
  onClearFilter: () => void;
}

export const ApplyWellListButton = function ({
  wellListRecord,
  setErrorMessage,
  isActive,
  onToggleActive,
  onClearFilter
}: IApplyWellListButton) {
  const dispatch = useDispatch();

  const toggleFilter = useCallback(() => {
    try {
      if (isActive) {
        dispatch(setFilterToSystemDefault());
        onToggleActive(null);
        toast.success("Well list removed");
      } else {
        dispatch(filterWellsFromList({ wellList: wellListRecord.wellList }));
        onToggleActive(wellListRecord.changeId);
        onClearFilter();
        toast.success("Well list applied!");
      }
      setErrorMessage(undefined);
    } catch (error) {
      toast.error("Error applying well list.");
      setErrorMessage("Error applying type well list.");
      Sentry.captureException(error);
    }
  }, [
    wellListRecord,
    dispatch,
    setErrorMessage,
    isActive,
    onToggleActive,
    onClearFilter
  ]);

  return (
    <Tooltip title={isActive ? "Remove Well List" : "Apply Well List"}>
      <StyledButton
        data-testid="applyWellListBtn"
        onClick={toggleFilter}
        className={isActive ? "favorite-active" : ""}>
        <Icon path={mdiPlaylistCheck} className="activity-action-icon" size={2} />
      </StyledButton>
    </Tooltip>
  );
};

const StyledButton = styled(Button)`
  color: #a2aaad;
  border: 1px solid #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1); // use ant-design transition
  }

  &:hover {
    color: var(--color-primary);
    border-color: var(--color-primary);
  }

  &.favorite-active {
    border-color: var(--color-primary);
    background: var(--color-primary);

    svg {
      color: white;
    }
  }

  &.favorite-active:hover {
    background: white;

    svg {
      color: var(--color-primary);
    }
  }
`;
